import axios from '../axios'

// フィードバック返信の修正（担当講師・1回）
const patchFeedbackReplyApi = async (feedbackId, body) => {
  return await axios.patch(`api/lms/feedback/${feedbackId}/reply`, { body })
}

export default patchFeedbackReplyApi
